import axios from '@/axios-mock'

const headers = {}

export function getCartNum () {
  return axios({
    url: `/app/cart/packs/size`
  })
  .then(({
    code,
    data
  }) => {
    return Promise.resolve(data)
  })
  .catch(err => {
    return Promise.reject(err)
  })
}


// WEBPACK FOOTER //
// ./static/components/app-header/api.js